__turbopack_context__.v({
  "btn-position-center": "Modal-module-scss-module__k1ZY8q__btn-position-center",
  "btn-position-right": "Modal-module-scss-module__k1ZY8q__btn-position-right",
  "indent": "Modal-module-scss-module__k1ZY8q__indent",
  "indent-bottom": "Modal-module-scss-module__k1ZY8q__indent-bottom",
  "indent-top": "Modal-module-scss-module__k1ZY8q__indent-top",
  "position-center": "Modal-module-scss-module__k1ZY8q__position-center",
  "position-left": "Modal-module-scss-module__k1ZY8q__position-left",
  "position-right": "Modal-module-scss-module__k1ZY8q__position-right",
});
